import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n";

export const Testimonial = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section ref={ref} className="relative py-28 md:py-48 bg-[#050505] overflow-hidden">
      <motion.div style={{ x }} className="absolute -top-4 left-0 whitespace-nowrap font-display font-black text-[22vw] leading-none marquee-outline opacity-[0.06] pointer-events-none">
        FIXEDRONE
      </motion.div>
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16 relative">
        <span className="font-display text-primary-c text-7xl md:text-9xl leading-none">"</span>
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="font-display font-medium text-3xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight max-w-5xl -mt-8"
        >
          {t.quote}
        </motion.blockquote>
        <div className="mt-10 flex items-center gap-4">
          <span className="w-12 h-px bg-[var(--primary)]" />
          <span className="font-mono-p text-sm uppercase tracking-widest text-white/60">{t.quoteAuthor}</span>
        </div>
      </div>
    </section>
  );
};
